import { useState, useCallback } from 'react'

interface UseHoverResult {
  isHovered: boolean
  onMouseEnter: () => void
  onMouseLeave: () => void
}

function useHover(): UseHoverResult {
  const [isHovered, setIsHovered] = useState(false)

  const onMouseEnter = useCallback(() => {
    setIsHovered(true)
  }, [])

  const onMouseLeave = useCallback(() => {
    setIsHovered(false)
  }, [])

  return {
    isHovered,
    onMouseEnter,
    onMouseLeave
  }
}

export { useHover }
